import React from 'react';
import { Brand } from 'AppSrc/core/components/header/brand';
import { HeaderSearch } from 'AppSrc/core/components/header/header-search';
import { HeaderUser } from 'AppSrc/core/components/header/header-user';
import { HeaderHelp } from 'AppSrc/core/components/header/header-help';
import 'AppSrc/core/style/components/header/header.css';
import { DevUserRoleControls } from './dev-user-role-controls';

const Header = React.memo((

) => (
  <>
    <div className="main-header main-header-spacemaker" />
    <div className="main-header">
      <div className="main-header-inner-container">
        <Brand />
        <HeaderSearch />
        <HeaderUser />
        <HeaderHelp />
        <DevUserRoleControls />
      </div>
    </div>
  </>
));

export { Header };

